export const navs = [
  // { name: 'Dashboard', rolesAllowed: ['admin', 'engineer'], path: '/dashboard' },
  { name: 'Commissioning Forms', rolesAllowed: ['admin', 'engineer'], path: '/allforms/' },
  { name: 'Create Forms', rolesAllowed: ['admin'], path: '/formChecklist/' },
  { name: 'Form List', rolesAllowed: ['admin', 'engineer'], path: '/formList/' },
  { name: 'User Management', rolesAllowed: ['admin'], path: '/usermanagement' },
  { name: 'Assignment', rolesAllowed: ['admin'], path: '/assignment' },
];
